import React from 'react';
import { motion } from 'framer-motion';
import Button from './ui/Button';

const Hero = () => {
  return (
    <header className="relative pt-24 pb-16 lg:pt-32 lg:pb-24 overflow-hidden bg-aged-ivory border-b border-warm-stone/30">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="text-left"
        >
          <span className="text-olive-grove font-medium tracking-widest uppercase text-xs mb-6 block">
            Padua Weddings Planning & Venue Guide
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif text-deep-charcoal mb-8 leading-tight">
            A Historic Spanish Revival Wedding Venue <br className="hidden md:block" />
            <span className="italic font-light text-estate-bronze">in the Claremont Foothills</span>
          </h1>
          <p className="text-lg text-deep-charcoal/80 mb-10 leading-relaxed font-light">
            Experience an enchanting Southern California setting where historic architecture meets modern ease. Padua Weddings offers a romantic oasis designed to make your wedding day feel timeless, seamless, and deeply personal.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center gap-4">
            <Button href="https://tour.paduaweddings.com" variant="primary">
              Schedule Your Private Tour
            </Button>
            <Button href="#guides" variant="secondary">
              Explore the Wedding Guide
            </Button>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, delay: 0.2 }}
          className="relative"
        >
          <div className="aspect-[4/5] md:aspect-video lg:aspect-[4/5] rounded-2xl overflow-hidden shadow-editorial border border-warm-stone/40">
            <img 
              src="https://images-pw.pixieset.com/elementfield/K5PRwQe/160orangecountyweddingphotos-7b26bb3b-1500.JPG" 
              alt="Bride and groom kissing in the olive grove at Padua Weddings"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute -bottom-4 -right-4 bg-vintage-white p-4 rounded-lg shadow-sm border border-warm-stone/20 hidden md:block">
            <p className="text-xs font-serif italic text-estate-bronze">
              A romantic olive grove moment at Padua Weddings.
            </p>
          </div>
        </motion.div>
      </div>
      
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-20">
        <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-warm-stone blur-3xl"></div>
      </div>
    </header>
  );
};

export default Hero;